import styled, { css } from 'styled-components';

import { ICardContainer } from './card-container';

const listViewCss = css`
  flex-flow: column nowrap;
  padding: 0.25rem 0;
  width: 100%;
`;

const notListViewCss = css`
  padding: 0.5rem calc(100vw - 25.5rem) 0.5rem 0.5rem;
  ${Styles.mobileSmall`
    padding: 0.5rem 5vw;
  `}

  ${Styles.mobile`
    & > :not(:last-child) {
      margin-right: 0.5rem;
    }
  `}
`;

const Cards = styled.div<ICardContainer>`
  top: 0;
  display: inline-flex;

  ${Styles.desktop`
    ${listViewCss}
    position: relative;
    top: 0;
    margin: 0.25rem 0;
  `}
  ${p => (p.isListView ? listViewCss : notListViewCss)}
`;

export default Cards;
